import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { DigitalWaiverService } from '../../../services/digital-waiver.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { MatDialogRef } from '@angular/material/dialog';
import { DigitalWaiver } from '../../../models/digital-waiver';
import { ToolbarSettingsModel } from '@syncfusion/ej2-angular-dropdowns';
import { PasteCleanupSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
@Component({
    selector: 'waiver-edit-modal',
    templateUrl: './waiver-edit-modal.component.html',
    styleUrl: './waiver-edit-modal.component.scss',
    standalone: false
})
export class WaiverEditModalComponent extends BaseModalComponent implements OnInit {
  public waiver: DigitalWaiver;
  public form = new FormGroup({
    title: new FormControl('', [Validators.required]),
    legalTerms: new FormControl('', [Validators.required]),
    isActive: new FormControl(true)
  });

  public toolbarItems: ToolbarSettingsModel = {
    items: ['Undo', 'Redo', '|',
      'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
      'SubScript', 'SuperScript', '|',
      'LowerCase', 'UpperCase', '|',
      'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
      'Indent', 'Outdent', '|', 'CreateLink',
      'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
  };

  public pasteCleanupSettings: PasteCleanupSettingsModel = {
    prompt: true,
    plainText: false,
    keepFormat: true,
    deniedTags: ['a'],
    deniedAttrs: ['class', 'title', 'id'],
    allowedStyleProps: ['color', 'margin', 'font-size']
};

  constructor(
    private digitalWaiverService: DigitalWaiverService,
    private sessionService: SessionService,
    public dialogRef: MatDialogRef<WaiverEditModalComponent>
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.waiver) {
      this.form.patchValue({
        title: this.waiver.title,
        legalTerms: this.waiver.legalTerms,
        isActive: this.waiver.isActive
      });
    }
  }

  submit() {
    if (this.form.valid) {
      this.isLoading = true;
      const data = {
        ...this.form.value,
        id: this.waiver.id,
        organizationId: this.sessionService.getUser().organizationId,
        lastEditedBy: this.sessionService.getUserId()
      };

      this.digitalWaiverService.updateWaiver(this.waiver.id, data).subscribe({
        next: () => {
          this.dialogRef.close('save');
        },
        error: (error) => {
          this.isLoading = false;
          console.error(error);
        }
      });
    }
  }
} 